<div *ngIf="lineSymbol" class="draw-options symbol-editor">

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Apply color to entire layer:</label>
        <input type="checkbox" class="pull-right checkbox"
               [(ngModel)]="applyColorToEntireLayer" (change)="applyColorToEntireLayerCheckboxChange()">
    </div>

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left" for="style">Line Style</label>
        <select id="style" name="style" [(ngModel)]="lineStyle" class="right">
            <option *ngFor="let option of lineStyleOptions" [value]="option.value">{{ option.name }}</option>
        </select>
    </div>

    <div class="clearfix legendWideControlGroup" *ngIf="applyColorToEntireLayer">
        <label class="pull-left" (click)="layerColorPicker.showColorPicker = !layerColorPicker.showColorPicker">Layer Color:</label>
        <mc-color-picker-ng #layerColorPicker
                            class="color-swatch right"
                            [color]="symbolColor"
                            (colorChange)="updateColorFromPicker($event)">
        </mc-color-picker-ng>
        <a class="right cancel-button" *ngIf="!esriLayer || !(esriLayer.mapcoreProps.color === null || esriLayer.mapcoreProps.color === originalColor)" (click)="cancelColorChange('layerColor')">Cancel</a>
    </div>

    <div class="clearfix legendWideControlGroup" *ngIf="!applyColorToEntireLayer">
        <label class="pull-left" (click)="colorPicker.showColorPicker = !colorPicker.showColorPicker">Line Color:</label>
        <mc-color-picker-ng #colorPicker
                            class="color-swatch right"
                            [color]="symbolColor"
                            (colorChange)="updateColorFromPicker($event)">
        </mc-color-picker-ng>
        <a class="right cancel-button" *ngIf="symbolColor !== originalColor" (click)="cancelColorChange()">Cancel</a>
    </div>

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Line Width:</label>
        <input class="pull-right" type="text" style="width:100px" [(ngModel)]="lineWidth" />
    </div>
</div>
